(() => {
  if (window.__zetaRankingInitialized) {
    return;
  }
  window.__zetaRankingInitialized = true;

  const ROOT_SELECTOR = '[data-zeta-ranking]';
  const INITIALIZED_ATTRIBUTE = 'data-zeta-ranking-initialized';
  const ARROWS_INITIALIZED_ATTRIBUTE = 'data-zeta-ranking-arrows-initialized';
  const PROGRESS_INITIALIZED_ATTRIBUTE = 'data-zeta-ranking-progress-initialized';
  const DEFAULT_PRODUCTS_COUNT = 10;
  const FETCH_LIMIT = 50; // カラー展開ぶんを見込んだ1回あたりの取得件数
  const MAX_FETCH_ROUNDS = 2; // ユニーク件数が不足した場合の追加取得は1回まで
  const POPULARITY_SORT = '-popularity';
  const INCLUDE_SOLD_OUT = 0;
  const SCROLL_EDGE_TOLERANCE_PX = 1;
  const PREVIOUS_PAGE_DIRECTION = -1;
  const NEXT_PAGE_DIRECTION = 1;
  const FULL_PROGRESS_PERCENT = 100;
  const RANKING_CLASS_PREFIX = 'product-item__ranking--';

  function buildCard(root, item, rankingNumber) {
    const template = root.querySelector('[data-zeta-ranking-card-template]');
    if (!template) {
      return null;
    }

    const node = template.content.cloneNode(true);
    const imageLink = node.querySelector('[data-zeta-ranking-link]');
    const bodyLink = node.querySelector('[data-zeta-ranking-body-link]');
    const image = node.querySelector('[data-zeta-ranking-image]');
    const ranking = node.querySelector('[data-zeta-ranking-number]');
    const sold = node.querySelector('[data-zeta-ranking-sold]');
    const title = node.querySelector('[data-zeta-ranking-title]');
    const price = node.querySelector('[data-zeta-ranking-price]');
    const compare = node.querySelector('[data-zeta-ranking-compare]');
    const wishlistSlot = node.querySelector('[data-zeta-wishlist-slot]');

    if (!imageLink || !bodyLink || !image || !ranking || !sold || !title || !price || !compare) {
      return null;
    }

    imageLink.href = item.url;
    bodyLink.href = item.url;
    ranking.textContent = String(rankingNumber);
    ranking.setAttribute('aria-label', `ランキング ${rankingNumber}位`);
    ranking.classList.add(`${RANKING_CLASS_PREFIX}${rankingNumber}`);
    title.textContent = item.title;
    const discountedPrice = window.Anatai?.getDiscountedPrice(item.price) ?? null;
    if (discountedPrice !== null) {
      price.textContent = window.Zeta.formatMoney(discountedPrice);
      price.classList.add('c-product-card__price-sale');
      compare.textContent = window.Zeta.formatMoney(item.price);
      compare.hidden = false;
    } else {
      price.textContent = window.Zeta.formatMoney(item.price);
    }
    if (wishlistSlot) {
      wishlistSlot.dataset.zetaItemId = item.id;
      wishlistSlot.dataset.zetaSku = item.sku;
      wishlistSlot.dataset.zetaColorCode = item.colorCode;
      wishlistSlot.dataset.zetaColorName = item.colorName;
      wishlistSlot.dataset.zetaSoldOut = item.soldOut ? '1' : '0';
    }

    if (item.imageUrl) {
      image.src = item.imageUrl;
      image.alt = item.colorName ? `${item.title} ${item.colorName}` : item.title;
    }

    if (discountedPrice === null && item.onSale) {
      price.classList.add('c-product-card__price-sale');
    }
    if (discountedPrice === null && item.compareAtPrice != null) {
      compare.textContent = window.Zeta.formatMoney(item.compareAtPrice);
      compare.hidden = false;
    }

    return node;
  }

  function updateArrowState(scrollableElement, previousButton, nextButton) {
    const maxScrollLeft = scrollableElement.scrollWidth - scrollableElement.clientWidth;
    const currentScrollLeft = Math.abs(scrollableElement.scrollLeft);
    const isNotScrollable = maxScrollLeft <= SCROLL_EDGE_TOLERANCE_PX;

    previousButton.disabled = isNotScrollable || currentScrollLeft <= SCROLL_EDGE_TOLERANCE_PX;
    nextButton.disabled = isNotScrollable || currentScrollLeft >= maxScrollLeft - SCROLL_EDGE_TOLERANCE_PX;
  }

  // 内側paddingを除いた表示幅を1ページとして送る。
  function scrollByPage(scrollableElement, direction) {
    const innerElement = scrollableElement.querySelector('.scroller__inner');
    const listElement = scrollableElement.querySelector('[data-zeta-ranking-list]');
    if (!innerElement || !listElement) {
      return;
    }

    const innerStyle = window.getComputedStyle(innerElement);
    const paddingStart = parseFloat(innerStyle.paddingInlineStart) || 0;
    const paddingEnd = parseFloat(innerStyle.paddingInlineEnd) || 0;
    const columnGap = parseFloat(window.getComputedStyle(listElement).columnGap) || 0;
    const visibleWidth = scrollableElement.clientWidth - paddingStart - paddingEnd;

    scrollableElement.scrollBy({ left: (visibleWidth + columnGap) * direction, behavior: 'smooth' });
  }

  function setupArrows(root, scrollableElement) {
    if (root.hasAttribute(ARROWS_INITIALIZED_ATTRIBUTE)) {
      return;
    }

    const controls = root.querySelector('[data-zeta-ranking-controls]');
    const previousButton = controls?.querySelector('.c-zeta-ranking__arrow--prev');
    const nextButton = controls?.querySelector('.c-zeta-ranking__arrow--next');
    if (!controls || !previousButton || !nextButton) {
      return;
    }

    root.setAttribute(ARROWS_INITIALIZED_ATTRIBUTE, '');
    const synchronizeArrowState = () => updateArrowState(scrollableElement, previousButton, nextButton);

    root.addEventListener('prev-next:prev', () => scrollByPage(scrollableElement, PREVIOUS_PAGE_DIRECTION));
    root.addEventListener('prev-next:next', () => scrollByPage(scrollableElement, NEXT_PAGE_DIRECTION));
    scrollableElement.addEventListener('scroll', synchronizeArrowState, { passive: true });
    window.addEventListener('resize', synchronizeArrowState);
    synchronizeArrowState();
  }

  function setupProgressBar(root, scrollableElement) {
    if (root.hasAttribute(PROGRESS_INITIALIZED_ATTRIBUTE)) {
      return;
    }

    const track = root.querySelector('[data-zeta-ranking-progress-track]');
    const thumb = root.querySelector('[data-zeta-ranking-progress-thumb]');
    if (!track || !thumb) {
      return;
    }

    root.setAttribute(PROGRESS_INITIALIZED_ATTRIBUTE, '');
    let isUpdateScheduled = false;

    const updateProgress = () => {
      const scrollWidth = scrollableElement.scrollWidth;
      const clientWidth = scrollableElement.clientWidth;
      thumb.style.left = '0px';

      if (scrollWidth <= clientWidth + SCROLL_EDGE_TOLERANCE_PX) {
        track.hidden = true;
        thumb.style.width = `${FULL_PROGRESS_PERCENT}%`;
        return;
      }

      track.hidden = false;
      const revealedWidth = scrollableElement.scrollLeft + clientWidth;
      const widthRatio = Math.min(revealedWidth / scrollWidth, 1);
      thumb.style.width = `${widthRatio * FULL_PROGRESS_PERCENT}%`;
    };

    const scheduleUpdate = () => {
      if (isUpdateScheduled) {
        return;
      }
      isUpdateScheduled = true;
      window.requestAnimationFrame(() => {
        updateProgress();
        isUpdateScheduled = false;
      });
    };

    scrollableElement.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', updateProgress);
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(updateProgress);
      resizeObserver.observe(scrollableElement);
    }
    updateProgress();
  }

  function setupGallery(root) {
    const gallery = root.querySelector('[data-zeta-ranking-gallery]');
    const scrollableElement = root.querySelector('[data-zeta-ranking-scroller]');
    if (!gallery || !scrollableElement) {
      return;
    }

    gallery.listItems = Array.from(gallery.querySelectorAll('gallery-item'));
    gallery.listWrapperElement = gallery.querySelector('.gallery__list-wrapper');
    setupArrows(root, scrollableElement);
    setupProgressBar(root, scrollableElement);

    window.requestAnimationFrame(() => {
      gallery.listWrapperElement?._checkScrollability();
      const controls = root.querySelector('[data-zeta-ranking-controls]');
      const previousButton = controls?.querySelector('.c-zeta-ranking__arrow--prev');
      const nextButton = controls?.querySelector('.c-zeta-ranking__arrow--next');
      if (previousButton && nextButton) {
        updateArrowState(scrollableElement, previousButton, nextButton);
      }
    });
  }

  function hideSection(root) {
    if (window.Shopify?.designMode === true) {
      return;
    }
    const section = root.closest('.shopify-section');
    (section || root).hidden = true;
  }

  function showEmptyState(root) {
    const empty = root.querySelector('[data-zeta-ranking-empty]');
    if (!empty) {
      hideSection(root);
      return;
    }

    empty.hidden = false;

    const scroller = root.querySelector('[data-zeta-ranking-scroller]');
    if (scroller) {
      scroller.hidden = true;
    }

    const controls = root.querySelector('[data-zeta-ranking-controls]');
    if (controls) {
      controls.hidden = true;
    }

    const progress = root.querySelector('[data-zeta-ranking-progress-track]');
    if (progress) {
      progress.hidden = true;
    }
  }

  async function fetchRankingItems(productsCount, category) {
    const representativeItems = new Map();
    const itemIds = [];

    for (let round = 0; round < MAX_FETCH_ROUNDS; round += 1) {
      const params = {
        q: '',
        l: FETCH_LIMIT,
        o: round * FETCH_LIMIT,
        s: POPULARITY_SORT,
        stock: INCLUDE_SOLD_OUT,
      };
      if (category) {
        params.filters = { category: [category] };
      }

      const result = await window.Zeta.fetchItems(params);
      const items = Array.isArray(result.items) ? result.items : [];

      items.forEach((item) => {
        if (!item.id) {
          return;
        }

        const representativeItem = representativeItems.get(item.id);
        if (!representativeItem) {
          representativeItems.set(item.id, item);
          itemIds.push(item.id);
          return;
        }

        // 商品のカラー並びで先頭の色を代表にする。
        if (
          item.colorPosition != null &&
          (representativeItem.colorPosition == null || item.colorPosition < representativeItem.colorPosition)
        ) {
          representativeItems.set(item.id, item);
        }
      });

      // 最後に追加した商品の全カラーを比較するため、ラウンド内は最後まで走査してから判定する。
      if (itemIds.length >= productsCount || items.length < FETCH_LIMIT) {
        break;
      }
    }

    return itemIds.map((itemId) => representativeItems.get(itemId)).slice(0, productsCount);
  }

  async function initializeRanking(root) {
    if (root.hasAttribute(INITIALIZED_ATTRIBUTE)) {
      return;
    }
    root.setAttribute(INITIALIZED_ATTRIBUTE, '');

    const list = root.querySelector('[data-zeta-ranking-list]');
    const productsCount = parseInt(root.dataset.productsCount, 10) || DEFAULT_PRODUCTS_COUNT;
    const category = root.dataset.zetaRankingCategory || '';
    if (!list) {
      hideSection(root);
      return;
    }

    try {
      const items = await fetchRankingItems(productsCount, category);
      if (items.length === 0) {
        showEmptyState(root);
        return;
      }

      const fragment = document.createDocumentFragment();
      items.forEach((item, index) => {
        const card = buildCard(root, item, index + 1);
        if (card) {
          fragment.appendChild(card);
        }
      });
      list.appendChild(fragment);

      if (list.children.length === 0) {
        showEmptyState(root);
        return;
      }
      setupGallery(root);
      await window.Zeta.hydrateProductCards(list, {
        className: 'c-product-card__wishlist',
        soldSelector: '[data-zeta-ranking-sold]',
        imageSelector: '[data-zeta-ranking-image]',
        hoverImageSelector: '[data-zeta-ranking-image-hover]',
        cardRootSelector: '.c-product-card',
        linkSelectors: ['[data-zeta-ranking-link]', '[data-zeta-ranking-body-link]'],
      });
    } catch (error) {
      console.error('[ZETA Ranking]', error);
      hideSection(root);
    }
  }

  function initializeRankings() {
    const roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!window.Zeta) {
      roots.forEach((root) => hideSection(root));
      return;
    }
    roots.forEach((root) => initializeRanking(root));
  }

  initializeRankings();
  document.addEventListener('shopify:section:load', initializeRankings);
})();
